/**
 * Where this project lives. Forks: point REPO_URL at your own repository so the
 * in-app "Setup guide" link opens your docs.
 */
export const REPO_URL = 'https://github.com/vulrun/cashrow'
export const SETUP_GUIDE_URL = `${REPO_URL}/blob/main/docs/google-cloud-setup.md`
